import styles from './SellAdvert.module.scss';
import Heading from './components/Heading/Heading';
import Gallery from './components/Gallery/Gallery';
import Info from './components/Info/Info';
import Map from './components/Map/Map';
import Description from './components/Description/Description';
import AdditionalInfo from './components/AdditionalInfo/AdditionalInfo';
import Price from './components/Price/Price';
import Main from '../../containers/Main/Main';
import SectionWrapper from '../../containers/SectionWrapper/SectionWrapper';

const SellAdvert = () => {
	return (
		<Main>
			<SectionWrapper>
				<div className={styles.container}>
					<div className={styles.ASide}>
						<div className={styles.headingContainer}>
							<Heading />
							<Gallery />
						</div>
						<Info />
						<Map />
						<Description />
						<AdditionalInfo />
					</div>
					<div className={styles.BSide}>
						<Price />
					</div>
				</div>
			</SectionWrapper>
		</Main>
	);
};

export default SellAdvert;
